import { AddCorridorsToAnatomy } from "./index2.js";
import { ResizeTendonsToMuscles } from "./index56.js";
import { getActiveBuildings } from "./index183.js";
const pipeAddCorridors = ([parent, { buildingIds, aggProps }]) => {
  const dataset = aggProps.dataset;
  const buildings = getActiveBuildings(parent, aggProps);
  for (const building of buildings) {
    if (buildingIds && !buildingIds.includes(building.uuid))
      continue;
    ResizeTendonsToMuscles(building, dataset.aggConfig.corridorWidth, !!dataset.aggConfig.gridCellWidth);
    AddCorridorsToAnatomy(building, dataset);
  }
  return [parent, void 0];
};
export {
  pipeAddCorridors
};
//# sourceMappingURL=index88.js.map
